import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';
import createLogger from 'vuex/dist/logger';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

const vuexPersist = new VuexPersist({
  key: '@sapitur/servidor-online',
  storage: window.localStorage,
});

const data = {
  logged: {
    codigo: '',
    cpf: '',
  },
  city: {
    id: '',
    name: '',
    unidadeGestora: '',
    flag: '',
  },
  tokens: {
    access_token: '',
    refresh_token: '',
    expires_in: '',
  },
};

const getters = {
  getLogged: (state) => state.logged,
  getCity: (state) => state.city,
  isLogged: (state) => !!state.logged.cpf,
};

const mutations = {
  SET_LOGGED(state, payload) {
    state.logged = payload;
  },
  SET_CITY(state, payload) {
    state.city = payload;
  },
  SET_TOKENS(state, payload) {
    state.tokens = payload;
  },
  LOGOUT(state) {
    state.logged = {};
    state.tokens = {};
  },
};
const actions = {
  SET_LOGGED({ commit }, payload) {
    commit('SET_LOGGED', payload);
  },
  SET_CITY({ commit }, payload) {
    commit('SET_CITY', payload);
  },
  SET_TOKENS({ commit }, payload) {
    commit('SET_TOKENS', payload);
  },
  LOGOUT({ commit }) {
    commit('LOGOUT');
  },
};

const plugins = [vuexPersist.plugin];

export default new Vuex.Store({
  state: data,
  getters,
  mutations,
  actions,
  strict: debug,
  plugins: debug ? [...plugins, createLogger()] : plugins,
});
